import { render, staticRenderFns } from "./DrugIdLabel.vue?vue&type=template&id=1bd4f58e&scoped=true"
import script from "./DrugIdLabel.vue?vue&type=script&lang=js"
export * from "./DrugIdLabel.vue?vue&type=script&lang=js"
import style0 from "./DrugIdLabel.vue?vue&type=style&index=0&id=1bd4f58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4f58e",
  null
  
)

export default component.exports